/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Product,
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateProductResponse
 */
export interface CreateProductResponse {
    /**
     * 
     * @type {Product}
     * @memberof CreateProductResponse
     */
    product: Product;
}

export function CreateProductResponseFromJSON(json: any): CreateProductResponse {
    return CreateProductResponseFromJSONTyped(json, false);
}

export function CreateProductResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProductResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product': ProductFromJSON(json['product']),
    };
}

export function CreateProductResponseToJSON(value?: CreateProductResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product': ProductToJSON(value.product),
    };
}


